/* eslint-disable max-params */
import interceptor from './interceptor';
import { apiUrl, adminsImageUrl } from '../environment/index';

const baseURL = `${apiUrl}/admins`;

export const adminsGetAllBenefits = (
  id = '',
  page,
  benefitType = 'all',
  keyword = '',
  approvalFilter = '',
  sponsoredFilter = false,
  nationwideFilter = false,
  governmentFilter = false,
  categoryIds = []
  // eslint-disable-next-line max-params
) => {
  const queryParams = new URLSearchParams({
    id,
    page,
    benefitType,
    keyword,
    approvalFilter,
    sponsoredFilter,
    nationwideFilter,
    governmentFilter,
    categoryIds: categoryIds.join(','),
  });
  return interceptor.get(`${apiUrl}/admins/benefits?${queryParams}`);
};

export const getBenefitCategories = () => {
  return interceptor.get(`${apiUrl}/admins/benefits/category`);
};

export const adminsCreateBenefit = (benefit) => {
  return interceptor.post(`${baseURL}/benefits`, benefit);
};

export const adminsBatchUpdateBenefits = (benefitCsv) => {
  return interceptor.post(`${baseURL}/benefits/batch-update`, benefitCsv);
};

// benefits: reviewed records from adminsBatchUpdateBenefits, minus ignored
export const adminsBatchCommitBenefits = (benefits) => {
  return interceptor.post(`${baseURL}/benefits/batch-commit`, { benefits });
};

export const adminsUpdateBenefit = (benefit) => {
  return interceptor.put(`${baseURL}/benefits/${benefit._id}`, benefit);
};

export const adminsUpdateBenefitApproval = (id, approval) => {
  return interceptor.put(`${baseURL}/benefits/approval/${id}`, approval);
};

export const adminsDeleteBenefit = (benefitId) => {
  return interceptor.delete(`${baseURL}/benefits/${benefitId}`);
};

export const adminsCloneBenefit = (benefitId) => {
  return interceptor.post(`${baseURL}/benefits/clone/${benefitId}`);
};

export const adminsCreateBenefitCategory = (category) => {
  return interceptor.post(`${baseURL}/benefits/category`, category);
};

export const adminsUpdateBenefitCategory = (category) => {
  return interceptor.put(
    `${baseURL}/benefits/category/${category._id}`,
    category
  );
};

export const adminsDeleteBenefitCategory = (categoryId) => {
  return interceptor.delete(`${baseURL}/benefits/category/${categoryId}`);
};

export const adminsGetAllUsers = (
  keyword = '',
  page = 1,
  limit = 25,
  startDate,
  endDate,
  roleFilter,
  sortBy = 'createdAt',
  sortDirection = 'desc'
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(
    `${baseURL}/users?keyword=${keyword}&page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&roleFilter=${roleFilter}&sortBy=${sortBy}&sortDirection=${sortDirection}`
  );
};

export const adminsGetUser = (id) => {
  return interceptor.get(`${baseURL}/users/${id}`);
};

export const adminsDeleteUser = (userId) => {
  return interceptor.delete(`${baseURL}/users/${userId}`);
};

export const adminsUpdateUserPassword = (user) => {
  return interceptor.put(`${baseURL}/users/${user._id}/update-password`, user);
};

export const adminsUpdateUser = (user) => {
  return interceptor.put(`${baseURL}/users/${user._id}`, user);
};

export const adminsGetLeadPartners = (
  keyword = '',
  page = 1,
  limit = 25,
  sortBy = 'createdAt',
  sortDirection = 'desc',
  filterValues = []
) => {
  return interceptor.get(`${baseURL}/users/lead-partners`, {
    params: {
      keyword,
      page,
      limit,
      sortBy,
      sortDirection,
      filterValues: filterValues.join(','),
    },
  });
};

export const adminsSetUp2Factor = () => {
  return interceptor.post(`${baseURL}/users/set-up-2fa`);
};

export const adminsUpdate2Factor = (user, enable, token) => {
  return interceptor.put(
    `${baseURL}/users/${user._id}/update-2fa?enable=${enable}`,
    { ...user, token }
  );
};

export const adminsGetAllUserEvents = (
  page = 1,
  userTypeFilter = '',
  startDate = '',
  endDate = '',
  limit = 25,
  typefilter = ''
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(
    `${baseURL}/user-events?page=${page}&userTypeFilter=${userTypeFilter}&startDate=${startDate}&endDate=${endDate}&limit=${limit}&typeFilter=${typefilter}`
  );
};

export const adminsGetUserEventsForUser = (
  userId,
  page = 1,
  startDate = '',
  endDate = ''
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(
    `${baseURL}/user-events/by-user/${userId}?page=${page}&startDate=${startDate}&endDate=${endDate}`
  );
};

export const adminsExportUsers = (
  startDate = '',
  endDate = '',
  searchKeywords = '',
  roleFilter = ''
) => {
  return interceptor.get(
    `${baseURL}/export/users?startDate=${startDate}&endDate=${endDate}&searchKeywords=${searchKeywords}&roleFilter=${roleFilter}`,
    {
      responseType: 'blob',
      timeout: 30000,
    }
  );
};

export const adminsExportLeadPartners = (searchKeywords = '', filterValues) => {
  return interceptor.get(`${baseURL}/export/lead-partners`, {
    params: {
      searchKeywords,
      filterValues: filterValues.join(','),
    },
    responseType: 'blob',
    timeout: 30000,
  });
};

export const adminsExportBenefits = (
  approvalFilter = '',
  searchTerm = '',
  sponsoredFilter = false,
  nationwideFilter = false,
  governmentFilter = false,
  categoryIds = []
) => {
  const queryParams = new URLSearchParams({
    approvalFilter,
    searchTerm,
    sponsoredFilter,
    nationwideFilter,
    governmentFilter,
    categoryIds: categoryIds.join(','),
  });

  return interceptor.get(`${baseURL}/export/benefits?${queryParams}`, {
    responseType: 'blob',
    timeout: 30000,
  });
};

export const adminsExportResourceItems = () => {
  return interceptor.get(`${baseURL}/export/resource-items`, {
    responseType: 'blob',
    timeout: 30000,
  });
};

export const adminsExportBenefitBrokenLinks = () => {
  return interceptor.get(`${baseURL}/export/benefits-broken-links`, {
    responseType: 'blob',
  });
};

export const adminsExportReferrals = (
  startDate = '',
  endDate = '',
  filterValues = [],
  searchKeywords
) => {
  return interceptor.get(`${baseURL}/export/referrals`, {
    params: {
      startDate,
      endDate,
      filterValues: filterValues.join(','),
      searchKeywords,
    },
    responseType: 'blob',
    timeout: 30000,
  });
};

export const adminsExportReferralsNew = (
  startDate = '',
  endDate = '',
  filterValues = [],
  searchKeywords
) => {
  return interceptor.get(`${baseURL}/export/referrals-new`, {
    params: {
      startDate,
      endDate,
      filterValues: filterValues.join(','),
      searchKeywords,
    },
    responseType: 'blob',
    timeout: 30000,
  });
};

export const adminsExportUserEvents = (
  startDate = '',
  endDate = '',
  typeFilter = '',
  userTypeFilter = '',
  userId = ''
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(
    `${baseURL}/export/user-events?startDate=${startDate}&endDate=${endDate}&typeFilter=${typeFilter}&userId=${userId}&userTypeFilter=${userTypeFilter}`,
    {
      responseType: 'blob',
      timeout: 30000,
    }
  );
};

export const adminsExportUserDeletedEvents = (startDate = '', endDate = '') => {
  return interceptor.get(
    `${baseURL}/export/user-deleted-events?startDate=${startDate}&endDate=${endDate}`,
    {
      responseType: 'blob',
      timeout: 30000,
    }
  );
};

export const adminsExportUserSessionEvents = (startDate = '', endDate = '') => {
  return interceptor.get(
    `${baseURL}/export/users-sessions?startDate=${startDate}&endDate=${endDate}`,
    {
      responseType: 'blob',
      timeout: 30000,
    }
  );
};

export const addFaq = (faq) => {
  return interceptor.post(`${apiUrl}/admins/faq`, faq);
};

export const updateFaqOrder = (faq) => {
  return interceptor.put(`${apiUrl}/admins/faq`, faq);
};

export const updateFaq = (faq) => {
  return interceptor.put(`${apiUrl}/admins/faq/${faq._id}`, faq);
};

export const deleteFaq = (faqId) => {
  return interceptor.delete(`${apiUrl}/admins/faq/${faqId}`);
};

// @todo Need to refactor to accept a single object argument instead of multiple.
export const adminsGetFeedbacks = (
  page = 1,
  type = 'All',
  startDate = '',
  endDate = ''
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(
    `${apiUrl}/admins/feedback?page=${page}&type=${type}&startDate=${startDate}&endDate=${endDate}`
  );
};

export const adminsUpdateFeedback = (feedback) => {
  return interceptor.put(`${apiUrl}/admins/feedback/${feedback._id}`, feedback);
};

export const deleteFeedback = (feedbackId) => {
  return interceptor.delete(`${apiUrl}/admins/feedback/${feedbackId}`);
};

export const deleteFeedbackReply = (feedbackId, replyId) => {
  return interceptor.delete(
    `${apiUrl}/admins/feedback/${feedbackId}/reply/${replyId}`
  );
};

export const updateFeedbackReply = (feedbackId, reply) => {
  return interceptor.put(
    `${apiUrl}/admins/feedback/${feedbackId}/reply/${reply._id}`,
    reply
  );
};

export const adminsAddFeedbackReply = (feedbackId, reply) => {
  return interceptor.post(
    `${apiUrl}/admins/feedback/${feedbackId}/reply`,
    reply
  );
};

export const addPage = (page) => {
  return interceptor.post(`${apiUrl}/admins/pages/${page.slug}`, page);
};

export const updatePage = (page) => {
  return interceptor.put(`${apiUrl}/admins/pages/${page.slug}`, page);
};

export const deletePage = (page) => {
  return interceptor.delete(`${apiUrl}/admins/pages/${page.slug}`);
};

export const adminsGetAllResources = (search = '') => {
  return interceptor.get(`${apiUrl}/admins/resources?search=${search}`);
};

export const createResource = (resource) => {
  return interceptor.post(`${apiUrl}/admins/resources`, resource);
};

export const updateResource = (resource, approvalUpdate = false) => {
  return interceptor.put(
    `${apiUrl}/admins/resources/${resource._id}?approvalUpdate=${approvalUpdate}`,
    resource
  );
};

export const updateResourceOrder = (resources) => {
  return interceptor.put(`${apiUrl}/admins/resources`, resources);
};

export const deleteResource = (resourceId) => {
  return interceptor.delete(`${apiUrl}/admins/resources/${resourceId}`);
};

// update a order of resourceItems
export const updateResourceItemOrder = (item) => {
  return interceptor.put(
    `${apiUrl}/admins/resources/updateItem/${item._id}`,
    item
  );
};

export const createResourceItem = (item, resourceId) => {
  return interceptor.post(
    `${apiUrl}/admins/resources/${resourceId}/items`,
    item
  );
};

export const createMiscResourceItem = (item) => {
  return interceptor.post(`${apiUrl}/admins/resources/new-misc-item`, item);
};

export const updateResourceItem = (
  item,
  resourceId,
  approvalUpdate = false
) => {
  return interceptor.put(
    `${apiUrl}/admins/resources/${resourceId}/items/${item._id}?approvalUpdate=${approvalUpdate}`,
    item
  );
};

export const updateResourceItemPromotionalEmails = (itemId, body) => {
  return interceptor.put(
    `${apiUrl}/admins/resources/update-resource-promotional-emails/${itemId}`,
    body
  );
};

export const deleteResourceItem = (itemId, resourceId) => {
  return interceptor.delete(
    `${apiUrl}/admins/resources/${resourceId}/items/${itemId}`
  );
};

export const getResourceItems = (search, leadPartnerFilter = false) => {
  return interceptor.get(
    `${apiUrl}/admins/resources/items/?search=${search}&leadPartnerFilter=${leadPartnerFilter}`
  );
};

export const adminsGetResourceItem = (id) => {
  return interceptor.get(`${apiUrl}/admins/resources/items/${id}`);
};

export const getResourceItemBenefits = (itemId) => {
  return interceptor.get(`${apiUrl}/admins/resources/items/${itemId}/benefits`);
};

export const adminsGetResourceDetails = (resourceId, page = 1, search = '') => {
  return interceptor.get(
    `${apiUrl}/admins/resources/${resourceId}?page=${page}&search=${search}`
  );
};

export const getReferralsWithTypes = (
  page = 1,
  startDate,
  endDate,
  keyword = '',
  limit = 25,
  filterValues = []
  // eslint-disable-next-line max-params
) => {
  return interceptor.get(`${baseURL}/referral/new`, {
    params: {
      page,
      startDate,
      endDate,
      keyword,
      limit,
      filterValues: filterValues.join(','),
    },
  });
};

export const deleteReferral = (referralId) => {
  return interceptor.delete(`${baseURL}/referral/${referralId}`);
};

export const adminsGetAllReferralTypes = (
  approved = false,
  displayStats = false
) => {
  return interceptor.get(
    `${baseURL}/referral-types?approved=${approved}&displayStats=${displayStats}`
  );
};

export const adminsGetReferralType = (typeId) => {
  return interceptor.get(`${baseURL}/referral-types/${typeId}`);
};

export const adminsAddReferralType = (referralType) => {
  return interceptor.post(`${baseURL}/referral-types/`, referralType);
};

export const adminsEditReferralType = (typeId, referralType) => {
  return interceptor.put(`${baseURL}/referral-types/${typeId}`, referralType);
};

export const adminsDeleteReferralType = (typeId) => {
  return interceptor.delete(`${baseURL}/referral-types/${typeId}`);
};

export const sortReferralTypes = (referralTypes) => {
  return interceptor.put(`${baseURL}/referral-types/sort`, referralTypes);
};

export const uploadImage = (file) => {
  return interceptor.post(`${adminsImageUrl}/upload`, file);
};

export const getUserRankStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-ranks?${queryParams}`
  );
};

export const getUserMilRelationStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-military-affiliations?${queryParams}`
  );
};

export const getUserDisabilityRatingStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-disability-ratings?${queryParams}`
  );
};

export const getUserBranchStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-branches?${queryParams}`
  );
};

export const getUserStatusStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-status?${queryParams}`
  );
};

export const getUserAttributesStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-attributes?${queryParams}`
  );
};

export const getUserStatesStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-states?${queryParams}`
  );
};

export const getUserEmploymentAndHousingStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-employment-housing-status?${queryParams}`
  );
};

export const getUserExposureStatistics = (filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-exposure-to-hazards?${queryParams}`
  );
};

export const getReferralStatistics = (startDate, endDate) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/referrals?startDate=${startDate}&endDate=${endDate}`
  );
};

export const getCategoryViewsStatistics = (startDate, endDate) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/category-views?startDate=${startDate}&endDate=${endDate}`
  );
};

export const getBenefitViewedStatistics = (
  startDate,
  endDate,
  itemId = '',
  benefitId = ''
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/benefits-viewed?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}&benefitId=${benefitId}`
  );
};

export const getBenefitPhoneStatistics = (
  startDate,
  endDate,
  itemId = '',
  benefitId = ''
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/phone-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}&benefitId=${benefitId}`
  );
};

export const getBenefitEmailStatistics = (
  startDate,
  endDate,
  itemId = '',
  benefitId = ''
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/email-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}&benefitId=${benefitId}`
  );
};

export const getOrganizationOutboundClicksStatistics = (startDate, endDate) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/organization-outbound-clicks?startDate=${startDate}&endDate=${endDate}`
  );
};

export const getBenefitOutboundClicksStatistics = (
  startDate,
  endDate,
  itemId = '',
  benefitId = ''
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/benefit-outbound-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}&benefitId=${benefitId}`
  );
};

export const getUserSessionsStatistics = (startDate, endDate) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/user-sessions?startDate=${startDate}&endDate=${endDate}`
  );
};

export const getResourceItemStatistics = (itemId, startDate, endDate) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/resource-items?itemId=${itemId}&startDate=${startDate}&endDate=${endDate}`
  );
};

export const getResourceItemEmailStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/resource-item-email-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getResourceItemPhoneStatistics = (
  startDate,
  endDate,
  itemId = ''
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/resource-item-phone-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}`
  );
};

export const getReadMoreClickStatistics = (
  startDate,
  endDate,
  itemId = '',
  benefitItem = false
) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/read-more-clicks?startDate=${startDate}&endDate=${endDate}&itemId=${itemId}&benefitItem=${benefitItem}`
  );
};

export const getLeadPartnerReferralStatistics = (startDate, endDate) => {
  return interceptor.get(
    `${apiUrl}/admins/statistics/lead-partner-referrals?startDate=${startDate}&endDate=${endDate}`
  );
};
